<ng-container *ngTemplateOutlet="data?.template"></ng-container>
